import { ViewModel,View } from "binder"
import { getAsBoolean } from "src/uicomponents/components/utilities";
import { IStaticValueProvider } from "../IStaticValueProvider";
import  { BooleanEditorView } from "./booleanEditor-view"

export class BooleanEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new BooleanEditorView();
    }
    public getTypeId(): string {
        return "VM-05A95C3D-6B67-4A5B-B1FD-2300710AE18B"
    }

    public set value(v: boolean) { this._value = getAsBoolean(v); } public get value(): boolean { return this._value;} private _value: boolean;
    
    setValue(v: string) {
        this.value = getAsBoolean(v);
    }
    getValue(): string {
        return  this.value==null ? null : this.value.toString();
    }
    requestConfirm() {
    }

}
